import {
  EmailColumnDef,
  AddressColumnDef,
  CityColumnDef,
  CountryColumnDef,
  StateColumnDef,
  ZipcodeColumnDef,
  PhoneColumnDef,
  ContactColumnDef,
  PickUpWindowColumnDef,
  NumberCellStyle,
} from "components/AGTable/NewColumns/ColumnDefinition";

const defaultColDef = {
  sortable: true,
  resizable: true,
  cellClass: "no-border",
  cellStyle: { display: "flex", "justify-content": "center" },
  filter: true,
};

export const carrierDetailGrid = {
  columnDefs: [
    AddressColumnDef,
    CityColumnDef,
    StateColumnDef,
    CountryColumnDef,
    ZipcodeColumnDef("zipcode"),
    PhoneColumnDef,
    EmailColumnDef,
    ContactColumnDef,
    {
      headerName: "Min Wt (lbs)",
      cellStyle: NumberCellStyle,
      width: 115,
      field: "min_weight",
    },
    {
      headerName: "Max Wt (lbs)",
      cellStyle: NumberCellStyle,
      width: 115,
      field: "max_weight",
    },
    // {
    //   headerName: "Min Vol (ft³)",
    //   cellStyle: NumberCellStyle,
    //   width: 115,
    //   field: "min_volume",
    // },
    // {
    //   headerName: "Max Vol (ft³)",
    //   cellStyle: NumberCellStyle,
    //   width: 115,
    //   field: "max_volume",
    // },
    PickUpWindowColumnDef,
    {
      headerName: "Consolidator",
      width: 125,
      field: "xml",
      valueGetter: (params) => {
        return params.data.xml === true ? "Yes" : "No";
      },
    },
  ],
  defaultColDef,
};
